import { ca } from '@cian/analytics';

export const trackClickOffer = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Click',
    action: 'to_card',
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};

export const trackClickOfferPhone = (id: number | undefined, position: number, label: string | undefined) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_listing_company_block',
    label,
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
